import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { withRouter, Route } from "react-router-dom";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";

import Table from "../components/resources/Table";
import NewResource from "../components/resources/NewResource";

import Resource from "./Resource";

import { getResourcesForAdmin } from "../actions/resourceActions";
import { setActiveForm } from "../actions/appActions";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const Resources = ({
  history,
  match,
  location,
  resources,
  activeForm,
  setActiveForm
}) => {
  if (match.url === location.pathname) {
    return (
      <div className="flex-col">
        <TouchPageHeader title={"Zdroje"}/>
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>
        <Card>
          <CardText>
            <div className="margin-bottom-small">
              <Table resources={resources} history={history} />
            </div>
            {activeForm === "adminResourcesAddResourceForm" ? (
              <NewResource />
            ) : (
              <Button
                icon
                onClick={() => setActiveForm("adminResourcesAddResourceForm")}
              >
                add
              </Button>
            )}
          </CardText>
        </Card>
      </div>
    );
  }
  else
  {
    return (
      <Route
        path={`${match.url}/:id`}
        render={() => <Resource history={history} resources={resources} />}
      />
    );
  }
};

export default compose(
  withRouter,
  connect(
    ({ app: { form: { activeForm } }, resource: { resources } }) => ({
      activeForm,
      resources
    }),
    {
      getResourcesForAdmin,
      setActiveForm
    }
  ),
  lifecycle({
    componentWillMount() {
      const { getResourcesForAdmin } = this.props;

      getResourcesForAdmin();
    }
  })
)(Resources);



// WEBPACK FOOTER //
// ./src/pages/Resources.js